import React, { Component } from 'react';
import { withSnackbar } from 'notistack';
// mui
import { DialogContent, FormHelperText } from '@mui/material';
import { withStyles } from '@mui/styles';

// platform helpers
import { compose } from 'redux';
import { delayedEvent, PubSub } from '../utils/eventUtils';

import { hasUrl } from '../utils/appUtils';
import { AGENCY_QUOTES_LISTING_STORE_ID } from '../reducers/UiSettingsReducers';
// actions
import { deleteBulkQuote, deleteQuote } from './QuotesService';
import { withToggleModal } from '../components/hocs/withToggleModal';

const styles = ({ palette, config }: any) => {
  return {
    title: {
      fontFamily: 'Titillium Web',
      fontSize: config.textSizes.primer,
      fontWeight: 600,
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 1.8,
      letterSpacing: 'normal',
      textAlign: 'center',
      color: palette.text.text8,
    },
    text: {
      color: palette.primary.title,
    },
    greenText: {
      color: palette.text.text4,
    },
    error: {
      textAlign: 'center',
      maxWidth: '600px',
      fontSize: config.textSizes.normal,
    },
  };
};

class DeleteQuote extends Component {
  subscription: any;

  state: any;

  constructor(props: any) {
    super(props);
    if (props.data.length >= 2) {
      this.state = {
        quoteId: props.data,
        quoteNumber: '',
        // companyName: '',
        isCustomer: hasUrl('customer/'),
        error: '',
        isBulk: true,
      };
    } else {
      this.state = {
        quoteId: '',
        quoteNumber: '',
        // companyName: '',
        isCustomer: hasUrl('customer/'),
        error: '',
        isBulk: false,
      };
    }
  }

  componentDidMount() {
    const {
      // @ts-expect-error TS(2339): Property 'data' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      props: { data },
    } = this;

    if (data.length >= 2) {
      const quoteIds = data.map((quote: any) => quote.id);
      this.setState({
        quoteId: quoteIds,
      });
      this.subscription = PubSub.subscribe(
        'foot-button-one',
        (eventData: any) => {
          if (eventData) {
            this.handleSubmit();
          }
        }
      );
    } else {
      this.setState({
        quoteId: data.id,
        quoteNumber: data.quoteNumber,
      });
      this.subscription = PubSub.subscribe(
        'foot-button-one',
        (eventData: any) => {
          if (eventData) {
            this.handleSubmit();
          }
        }
      );
    }
  }

  componentWillUnmount() {
    this.subscription.remove();
  }

  handleSubmit = () => {
    PubSub.publish('loading', true);
    PubSub.publish('disabled', true);

    const updatePromise = this.state.isBulk
      ? deleteBulkQuote({ quoteIds: this.state.quoteId })
      : deleteQuote(this.state.quoteId);

    return updatePromise
      .then((response) => {
        PubSub.publish('loading', false);
        PubSub.publish('disabled', false);
        // @ts-expect-error TS(2339): Property 'toggleModal' does not exist on type 'Rea... Remove this comment to see the full error message
        this.props.toggleModal.direct('DeleteQuote', false);

        if (this.state.isCustomer) {
          delayedEvent('table-refetch', 500, 'customerQuotes');
        } else {
          delayedEvent('table-refetch', 500, AGENCY_QUOTES_LISTING_STORE_ID);
        }
        delayedEvent('table-refetch', 500, 'SalesInbox');
        delayedEvent('quote:read', 500, '');
        // @ts-expect-error TS(2339): Property 'enqueueSnackbar' does not exist on type ... Remove this comment to see the full error message
        this.props.enqueueSnackbar('Quote Deleted Successfully!', {
          variant: 'success',
        });
      })
      .catch((error) => {
        PubSub.publish('loading', false);
        PubSub.publish('disabled', false);
        // @ts-expect-error TS(2339): Property 'enqueueSnackbar' does not exist on type ... Remove this comment to see the full error message
        this.props.enqueueSnackbar('Failed to delete quote', {
          variant: 'error',
        });
      });
  };

  render() {
    // @ts-expect-error TS(2339): Property 'classes' does not exist on type 'Readonl... Remove this comment to see the full error message
    const { classes } = this.props;

    return (
      <DialogContent>
        {this.state.isBulk ? (
          <div className="modal-title">
            Are you sure you want to delete the selected Quotes?
          </div>
        ) : (
          <div className="modal-title">
            Are you sure you want to delete the Quote{' '}
            <span className={classes.greenText}> {this.state.quoteNumber}</span>{' '}
            ?
          </div>
        )}
        <FormHelperText className="api-text-error">
          {this.state.error}
        </FormHelperText>
      </DialogContent>
    );
  }
}

export default compose(
  withToggleModal,
  withSnackbar,
  // @ts-expect-error TS(2345): Argument of type '({ palette, config }: any) => { ... Remove this comment to see the full error message
  withStyles(styles)
)(DeleteQuote);
